import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import Formwizard from '../../../wizard/index.js';
import CustomNavigationButtons from './CustomNavigationButtons.js';
import CustomNavigationButtonsStart from './CustomNavigationButtonsStart.js';
import Layout from './Layout.js';
import ProgressBarCTA from './ProgressBarCTA.js';
import CustomWizardCard from './CustomWizardCard.js';
import { jsx } from '@emotion/react';
var CTA2 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(Layout, {
    ref: ref
  }, jsx(Formwizard, _extends({
    components: {
      ProgressBarCTA: ProgressBarCTA,
      CustomNavigationButtons: CustomNavigationButtons,
      CustomNavigationButtonsStart: CustomNavigationButtonsStart,
      CustomWizardCard: CustomWizardCard
    }
  }, props)));
});
export { CTA2 as default };